import request from './request'

export const _http = {
      //签署管理-签署详情
      getTaskinfo(params){
        return request({
            method: 'GET',
            url: '/platform/pc/fadada/task/info',
            params:params
        })
    },
      //签署管理-提交签署任务
      uploadtask(params){
        return request({
            method: 'GET',
            url: '/platform/pc/fadada/task/start',
            params:params
        })
    },
     //签署管理-创建签署任务
     createTask(params){
        return request({
            method: 'POST',
            url: '/platform/pc/fadada/task/create',
            data:params
        })
    },
    //法大大签署模板管理-签署模板列表
    getFadadaTemplate(params) {
        return request({
            method: 'POST',
            url: '/platform/pc/fadada/template/list',
            data:params
        })
    },
    //法大大签署模板管理-设置商家类型
    setFadadaTemplateApplyType(params) {
        return request({
            method: 'POST',
            url: '/platform/pc/fadada/template/save-apply-type',
            data:params
        })
    },
    //法大大签署模板管理-模板详情
    getFadadaTemplateDetail(params){
        return request({
            method: 'GET',
            url: '/platform/pc/fadada/template/detail',
            params:params
        })
    },
    //签署管理-查询企业实名认证状态
    getIdentifiedStatus(params) {
        return request({
            method: 'POST',
            url: '/platform/pc/fadada/task/corp/get-identified-status',
            data:params
        })
    },
    //签署管理-签署列表
    getFadadaTaskList(params) {
        return request({
            method: 'POST',
            url: '/platform/pc/fadada/task/list',
            data:params
        })
    },
    //签署管理-签署列表-参与方弹窗
    getFadadaTaskActors(params){
        return request({
            method: 'GET',
            url: '/platform/pc/fadada/task/actors',
            params:params
        })
    },
    //签署管理-撤销
    setFadadaTaskCancel(params) {
        return request({
            method: 'POST',
            url: '/platform/pc/fadada/task/cancel',
            data:params
        })
    },
    //签署管理-作废
    setFadadaTaskAbolish(params) {
        return request({
            method: 'POST',
            url: '/platform/pc/fadada/task/abolish',
            data:params
        })
    },
    //签署管理-下载链接
    getFadadaTaskDownloadUrl(params){
        return request({
            method: 'GET',
            url: '/platform/pc/fadada/task/get-download-url',
            params:params
        })
    },
    //签署管理-获取参与方签署链接
    getFadadaTaskActorUrl(params){
        return request({
            method: 'GET',
            url: '/platform/pc/fadada/task/actor/get-url',
            params:params
        })
    },
    //签署管理-查询必填控件是否填写
    getFadadaTaskFieldRequire(params) {
        return request({
            method: 'GET',
            url: '/platform/pc/fadada/task/field/nofill-require',
            params:params
        })
    },
    //签署管理-Q-已填写控件内容
    getFadadaFieldValue(params) {
        return request({
            method: 'GET',
            url: '/platform/pc/fadada/task/field/get-values',
            params:params
        })
    },
    //签署管理-填写控件内容
    setFadadaFieldValue(params) {
        return request({
            method: 'POST',
            url: '/platform/pc/fadada/task/field/fill-values',
            data:params
        })
    },
    // 签署任务列表导出
    TaskListExcel(params) {
        return request({
            method: 'POST',
            url: '/platform/pc/fadada/task/excel',
            data: params,
            responseType: 'blob'
        })
    },
}